export default __webpack_public_path__ + "static/media/clock.b445cb73.svg";